import React from 'react';

import Icon, { IconProps } from '../../icon';
import useStyles from './styles';

enum ChevronType {
  up = 'chevronUp',
  down = 'chevronDown',
  left = 'chevronLeft',
  right = 'chevronRight',
}

interface ChevronProps extends IconProps {
  type: ChevronType;
}

const Chevron = (type: ChevronType): string => {
  const classes = useStyles();
  return classes[type];
};

const ChevronIcon = ({ type, ...rest }: ChevronProps): JSX.Element => {
  const classes = useStyles();
  return <Icon icon={classes[type]} {...rest} />;
};

export const ChevronUp = (): string => Chevron(ChevronType.up);
export const ChevronDown = (): string => Chevron(ChevronType.down);
export const ChevronLeft = (): string => Chevron(ChevronType.left);
export const ChevronRight = (): string => Chevron(ChevronType.right);

export const ChevronUpIcon = (props: IconProps): JSX.Element => (
  <ChevronIcon type={ChevronType.up} {...props} />
);
export const ChevronDownIcon = (props: IconProps): JSX.Element => (
  <ChevronIcon type={ChevronType.down} {...props} />
);
export const ChevronLeftIcon = (props: IconProps): JSX.Element => (
  <ChevronIcon type={ChevronType.left} {...props} />
);
export const ChevronRightIcon = (props: IconProps): JSX.Element => (
  <ChevronIcon type={ChevronType.right} {...props} />
);
